import React from 'react';

export const DETAILIZATION_TAB_KEYS = {
    DAYS: '1',
    WEEKS: '2',
    MONTHS: '3'
};

export const DETAILIZATION_TABS = [
    {
        key: DETAILIZATION_TAB_KEYS.DAYS,
        label: <span data-e2e='performance_days-detalization_tab'>Days</span>,
        id: 'day'
    },
    {
        key: DETAILIZATION_TAB_KEYS.WEEKS,
        label: <span data-e2e='performance_weeks-detalization_tab'>Weeks</span>,
        id: 'week'
    },
    {
        key: DETAILIZATION_TAB_KEYS.MONTHS,
        label: <span data-e2e='performance_months-detalization_tab'>Months</span>,
        id: 'month'
    }
];
